
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface EnglishLegalDialogsProps {
  termsOpen: boolean;
  setTermsOpen: (value: boolean) => void;
  privacyPolicyOpen: boolean;
  setPrivacyPolicyOpen: (value: boolean) => void;
  openFullTerms?: () => void;
  openFullPrivacy?: () => void;
}

export const EnglishLegalDialogs = ({
  termsOpen,
  setTermsOpen,
  privacyPolicyOpen,
  setPrivacyPolicyOpen,
  openFullTerms,
  openFullPrivacy
}: EnglishLegalDialogsProps) => {
  const navigate = useNavigate();

  const handleFullTermsClick = () => {
    setTermsOpen(false);
    if (openFullTerms) {
      openFullTerms();
    } else {
      // Navigate to English terms page
      navigate("/en/terms");
    }
  };

  const handleFullPrivacyClick = () => {
    setPrivacyPolicyOpen(false);
    if (openFullPrivacy) {
      openFullPrivacy();
    } else {
      // Navigate to English privacy page
      navigate("/en/privacy");
    }
  };

  return (
    <>
      <Dialog open={termsOpen} onOpenChange={setTermsOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Terms of Service</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">These terms govern your use of the Lainasampo.fi loan comparison service.</p>
              <p className="mb-4">By using our service, you understand that we will share your application information with our partner banks and financial institutions for the purpose of making loan offers.</p>
              <p className="mb-4">You must provide accurate and truthful information in your loan application. Providing false information may result in your application being rejected and may be considered fraud.</p>
              <p className="mb-4">Lainasampo.fi does not guarantee that you will receive loan offers or that you will be approved for any loan. The decision to approve loans is made solely by our partner financial institutions according to their criteria.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullTermsClick}
              className="w-full md:w-auto"
            >
              Read the full Terms of Service
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setTermsOpen(false)}
              className="w-full md:w-auto"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      
      <Dialog open={privacyPolicyOpen} onOpenChange={setPrivacyPolicyOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Privacy Policy</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            <div className="max-h-[60vh] overflow-y-auto">
              <p className="mb-4">This Privacy Policy describes how Lainasampo.fi collects, uses, and shares your personal information when you use our service.</p>
              <p className="mb-4">We collect the personal information you provide in your loan application, including your name, contact details, financial information, and employment details.</p>
              <p className="mb-4">We share your information with our partner banks and financial institutions for the purpose of creating loan offers for you. We may also use your information to improve our service and communicate with you about your application.</p>
              <p className="mb-4">We implement appropriate security measures to protect your personal information and keep it only as long as required for the purposes outlined in this policy.</p>
            </div>
          </DialogDescription>
          <div className="flex flex-col md:flex-row justify-between mt-4 gap-2">
            <Button 
              type="button" 
              variant="outline" 
              onClick={handleFullPrivacyClick}
              className="w-full md:w-auto"
            >
              Read the full Privacy Policy
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => setPrivacyPolicyOpen(false)}
              className="w-full md:w-auto"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
